// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface CheckbookConfigOut {}

export const CheckbookConfigOutSerializer = {
  _fromJsonObject(_object: any): CheckbookConfigOut {
    return {};
  },

  _toJsonObject(_self: CheckbookConfigOut): any {
    return {};
  },
};
